import { fork, put, takeEvery } from "redux-saga/effects";
import { startLoading, setSuccess, setError } from "../store/appSlice";
import { setPaymentsProviders } from "../store/paymentsProvidersSlice";
import {
  fetchPaymentsProviders,
  paymentsProvidersOperationPaths,
} from "../store/paymentsProvidersSlice";
import { callApi } from "./helpers/api";
import * as PaymentsProvidersApi from "../api/PaymentsProviders";
// import * as PaymentsProvidersFakeApi from "../fakeApi/PaymentsProviders";

function* fetchPaymentsProvidersSaga({
  payload,
}: {
  payload: {
    id: string;
  };
  type: string;
}) {
  const { listing: operationPath } = paymentsProvidersOperationPaths();

  yield put(startLoading(operationPath));

  try {
    const data = yield callApi(PaymentsProvidersApi.getPaymentsProviders);

    yield put(setPaymentsProviders(data));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* watchFetchPaymentsProviders() {
  yield takeEvery(fetchPaymentsProviders.type, fetchPaymentsProvidersSaga);
}

export function* PaymentsProvidersSaga() {
  yield fork(watchFetchPaymentsProviders);
}
